import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
export const RfpClientListTitleSkeleton = (props) => {
    const { className = '' } = props;
    return (_jsxs("div", Object.assign({ className: className }, { children: [_jsx(Skeleton, { className: clsx('w-full h-[20px]') }), _jsx(Skeleton, { className: clsx('w-3/5 h-[20px]', 'mt-8') })] })));
};
